import { Game } from './game';

const canvas = document.getElementById('viewport') as HTMLCanvasElement | null;
const uiRoot = document.getElementById('ui-root');

if (!canvas || !uiRoot) {
  throw new Error('main: #viewport or #ui-root missing from index.html');
}

const game = new Game(canvas, uiRoot);

// Expose for debugging from the console.
(window as unknown as { game: Game }).game = game;

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
